import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput } from 'shared/components'

import { getOptionLabel, getOptionValue } from './helpers'

const TeamAthletesFiltersComponent = ({ form, loadSportTypes }) => (
  <Form form={form}>
    <Grid>
      <Row middle="xs">
        <Col xs={6} sm={4}>
          <FormInput
            name="search"
            icon="search"
            placeholder="Search by name..."
            grayBg
          />
        </Col>
        <Col xs={6} sm={4}>
          <FormInput
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="sportTypes"
            placeholder="Sport"
            loadOptions={loadSportTypes}
            oldInput
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

TeamAthletesFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  loadSportTypes: PropTypes.func.isRequired,
}

export default TeamAthletesFiltersComponent
